// extracted by mini-css-extract-plugin
export var animationContainer = "_g1-0";
export var asteriskIcon = "_g1-8";
export var conversationLeftSection = "_g1-4";
export var conversationListItem = "_g1-3";
export var conversationMiddleSection = "_g1-5";
export var conversationRightSection = "_g1-6";
export var detailsContent = "_g1-1";
export var listContainer = "_g1-7";
export var modalContent = "_g1-2";